import React, { Component } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { deleteContentTypeApi, getContentTypeApi } from "./Api";
import { connect } from "react-redux";
import { ComponentHeader, InformationModal } from "../common";
import ContentTypeForm from "./ContentTypeForm";
import { API_LIMIT, START_PAGE, isModuleExist, MODULE_ID_MAP } from "../../utils/Constant";
import { withRouter } from "../../utils/hoc/withRouter";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

export class ContentTypeTab extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.ContentMasterContentType);

    this.state = {
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      access: AccesData,
    };
  }
  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getContentTypeApi(this);
  }
  // todo---------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {
    deleteContentTypeApi(id, this, this.openCloseDeleteModal)
  }

  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;


    if (prevPage !== page) {
      this.setState({ currentPage: page }, () => {
        this.props.getContentTypeApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.contentTypeName} content type?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        {
          showEdit &&
          <ContentTypeForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Content Type"
          isSearch={false}
          placeholder={"Search speaker"}
          onChangeMethod={this.onChangeMethod}
          clearSearch={() => this.clearSearch()}
          primaryBtn=""
          handlePrimaryBtn={() => {
            this.setState({ showEdit: true })
          }}
        />
        <div className="commom-table-wrapper">

          <CustomTable
          ctx={this}
            data={listData?.list || []}
            columns={[
              {
                width: 250,
                title: "Name",
                dataIndex: "contentTypeName",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.contentTypeName;
                },
              },
              {
                width: 20,
                title: "Action",
                dataIndex: "",
                className: "",
                fixed: 'right',
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      <OptionsDropdown
                        editHandler={access?.updateAccess ? () => { this.showEditModal(rowData) } : null}  
                        deleteHandler={null}
                      />
                    );
                },
              }

            ]}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}
const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getContentTypeApi,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContentTypeTab));
